/**
 * Root layout rendered by the router: providers, theme, scroll restoration,
 * the service-worker update toast. Pages render through <Outlet />.
 */
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { ToastProvider } from '@/ui/components/Toast';
import { UpdatePrompt } from '@/ui/components/UpdatePrompt';
import { LedgerSyncNotices } from '@/ui/shell/LedgerSyncNotices';
import { useSettings } from '@/ui/hooks/useSettings';
import { useTheme } from '@/ui/hooks/useTheme';

function ThemeSync() {
  const settings = useSettings();
  useTheme(settings?.ui.theme);
  return null;
}

export function App() {
  return (
    <ToastProvider>
      <ThemeSync />
      <LedgerSyncNotices />
      <ScrollRestoration />
      <Outlet />
      <UpdatePrompt />
    </ToastProvider>
  );
}
